import React from 'react'


const Footer = () => {
    return (
        <footer className="footer">
            {/* <img src="https://res.cloudinary.com/acurunner79/image/upload/v1611198505/R2d4e146f5428a91d6d10a18e9a79794c_a4jjfo.jpg"></img> */}
        </footer>
    )
}


export default Footer
